export const NAVIGATION_HEIGHT = 44;
